import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import { savePostLoginRedirect } from '../utils/postLoginRedirect';

const EmailRedirect: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Aguardar até que a autenticação seja verificada
    if (isLoading) return;

    // Se estiver autenticado, ir direto para a GMUD
    if (isAuthenticated) {
      navigate(`/gmuds/${id}`, { replace: true });
    } else {
      // Guardar o destino: o login SSO recarrega a página e o state do router se perde
      savePostLoginRedirect(`/gmuds/${id}`, true);
      navigate('/login', {
        replace: true,
        state: {
          redirectTo: `/gmuds/${id}`,
          fromEmail: true,
        },
      });
    }
  }, [isAuthenticated, isLoading, navigate, id]);

  return (
    <div className='min-h-screen flex items-center justify-center bg-gray-50'>
      <div className='text-center'>
        <Loader2 className='h-8 w-8 animate-spin text-primary-600 mx-auto mb-4' />
        <p className='text-gray-600'>Redirecionando...</p>
      </div>
    </div>
  );
};

export default EmailRedirect;
